import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Download, X, Smartphone } from "lucide-react";

export function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setIsInstalled(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show prompt after 30s delay (don't annoy user immediately)
      const dismissed = localStorage.getItem("pwa_dismissed");
      if (!dismissed || Date.now() - parseInt(dismissed) > 7 * 24 * 60 * 60 * 1000) {
        setTimeout(() => setShowPrompt(true), 30000);
      }
    };

    window.addEventListener("beforeinstallprompt", handler);

    window.addEventListener("appinstalled", () => {
      setIsInstalled(true);
      setShowPrompt(false);
    });

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === "accepted") {
      setIsInstalled(true);
    }
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem("pwa_dismissed", Date.now().toString());
  };

  if (isInstalled || !showPrompt) return null;

  return (
    <div className="fixed bottom-20 right-4 z-50 max-w-[300px] animate-in slide-in-from-bottom-5 duration-500"
      data-testid="pwa-install-prompt">
      <div className="bg-[#0A1C3A] text-white rounded-2xl p-4 shadow-2xl border border-white/10">
        <div className="flex items-start gap-3">
          <div className="p-2 bg-white/10 rounded-xl">
            <Smartphone className="h-5 w-5" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold">Zainstaluj CRM</p>
            <p className="text-xs text-white/60 mt-0.5">
              Dodaj na ekran glowny dla szybszego dostepu
            </p>
          </div>
          <button onClick={handleDismiss} className="text-white/40 hover:text-white/80 -mt-1 -mr-1">
            <X className="h-4 w-4" />
          </button>
        </div>
        <Button onClick={handleInstall} size="sm"
          className="w-full mt-3 rounded-full bg-white text-[#0A1C3A] hover:bg-white/90 gap-2 text-xs font-semibold"
          data-testid="pwa-install-btn">
          <Download className="h-3.5 w-3.5" /> Zainstaluj aplikacje
        </Button>
      </div>
    </div>
  );
}
